import { personalSettings } from "../../../common/enums/personalSettings";

export const TaskEmailNotificationSettingsMap = new Map<string, string>([
    [personalSettings.editTaskEmail, "Редактирование"],
    [personalSettings.commentTaskEmail, "Комментарии"],
]);

export const ProjectEmailNotificationSettingsMap = new Map<string, string>([
    [personalSettings.createDeleteTaskEmail, "Создание/удаление задач"],
    [personalSettings.projectEditInfoEmail, "Редактирование общей информации"],
    [personalSettings.createDeleteSubprojectEmail, "Уведомления о подпроектах"],
    [personalSettings.createDeleteBoardEmail, "Уведомления о канбан-досках"],
    [personalSettings.editBoardEmail, "Редактирование канбан-досок"],
]);

export const TaskFrontNotificationSettingsMap = new Map<string, string>([
    [personalSettings.editTaskFront, "Редактирование"],
    [personalSettings.commentTaskFront, "Комментарии"],
]);

export const ProjectFrontNotificationSettingsMap = new Map<string, string>([
    [personalSettings.createDeleteTaskFront, "Создание/удаление задач"],
    [personalSettings.projectEditInfoFront, "Редактирование общей информации"],
    [personalSettings.createDeleteSubprojectInfoFront, "Уведомления о подпроектах"],
    [personalSettings.createDeleteBoardFront, "Уведомления о канбан-досках"],
    [personalSettings.editBoardFront, "Редактирование канбан-досок"],
]);


export const NotificationSettingsMap = new Map<string, string>(
    [
        ...Array.from(TaskEmailNotificationSettingsMap),
        ...Array.from(ProjectEmailNotificationSettingsMap),
        ...Array.from(TaskFrontNotificationSettingsMap),
        ...Array.from(ProjectFrontNotificationSettingsMap)
    ]
);